import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

declare let $: any;


@Component({
  selector: 'app-services-details-composting-solutions',
  templateUrl: './services-details-composting-solutions.component.html',
  styleUrls: ['./services-details-composting-solutions.component.css']
})
export class ServicesDetailsCompostingSolutionsComponent implements OnInit {

  public safeVideoURL5;

  public urlLoaded = false

  constructor(private _sanitizer: DomSanitizer) { 
    let videoURL5 = "https://www.youtube.com/embed/P-i19a92j84";
    this.safeVideoURL5 = this._sanitizer.bypassSecurityTrustResourceUrl(videoURL5);

    this.urlLoaded = true;
  }

  ngOnInit() {
    // FAQ Accordion
    $(function() {
      $('.accordion').find('.accordion-title').on('click', function(){
          // Adds Active Class
          $(this).toggleClass('active');
          // Expand or Collapse This Panel
          $(this).next().slideToggle('fast');
          // Hide The Other Panels
          $('.accordion-content').not($(this).next()).slideUp('fast');
          // Removes Active Class From Other Titles
          $('.accordion-title').not($(this)).removeClass('active');		
      });
    });
  }

}
